
import React from "react";
import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export const YhdistelylainaFAQ = () => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.4 }}
      className="mb-12"
    >
      <h2 className="text-2xl md:text-3xl font-bold text-gray-800 relative mb-8">
        <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-blue-500">
          Usein kysytyt kysymykset
        </span>
        <div className="absolute -bottom-2 md:-bottom-3 left-0 w-16 md:w-20 h-1 bg-blue-500"></div>
      </h2>
      <Accordion type="single" collapsible className="space-y-4">
        <AccordionItem value="item-1" className="bg-white rounded-lg border border-gray-200">
          <AccordionTrigger className="px-4 py-3 text-left hover:no-underline w-full">
            Miten yhdistelylaina toimii?
          </AccordionTrigger>
          <AccordionContent className="px-4 pb-3 text-gray-600">
            Yhdistelylaina on uusi laina, jolla maksetaan pois kaikki olemassa olevat pienemmät lainasi. 
            Tämän jälkeen maksat takaisin vain yhtä lainaa yhden koron mukaan. Uusi laina on yleensä koroltaan 
            edullisempi kuin pienemmät lainat, erityisesti luottokorttivelat ja kulutusluotot.
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="item-2" className="bg-white rounded-lg border border-gray-200">
          <AccordionTrigger className="px-4 py-3 text-left hover:no-underline w-full">
            Kuinka paljon voin säästää yhdistelylainalla?
          </AccordionTrigger>
          <AccordionContent className="px-4 pb-3 text-gray-600">
            Säästöjen määrä riippuu nykyisten lainojesi määrästä, koroista ja maksuajoista. Monet asiakkaat 
            säästvät satoja tai jopa tuhansia euroja. Esimerkiksi 20 000 euron lainasummalla jo kahden 
            prosenttiyksikön alennus korkotasossa voi tuoda yli 1000 euron säästöt viiden vuoden laina-ajalla.
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="item-3" className="bg-white rounded-lg border border-gray-200">
          <AccordionTrigger className="px-4 py-3 text-left hover:no-underline w-full">
            Kenelle yhdistelylaina sopii?
          </AccordionTrigger>
          <AccordionContent className="px-4 pb-3 text-gray-600">
            Yhdistelylaina sopii erityisesti henkilöille, joilla on useita eri lainoja korkeilla koroilla. 
            Se on myös hyödyllinen, jos haluat selkeyttää taloutesi hallintaa yhdistämällä kaikki maksut 
            yhdeksi eräksi. Hakijan tulee olla 20 vuotta täyttänyt Suomessa asuva henkilö, jolla on säännölliset 
            tulot ja kunnossa olevat luottotiedot.
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="item-4" className="bg-white rounded-lg border border-gray-200">
          <AccordionTrigger className="px-4 py-3 text-left hover:no-underline w-full">
            Mitä lainoja kannattaa yhdistää?
          </AccordionTrigger>
          <AccordionContent className="px-4 pb-3 text-gray-600">
            Yhdistelylainaan kannattaa yhdistää erityisesti kalliimpia lainoja kuten:
            <ul className="list-disc pl-5 mt-2">
              <li>Luottokorttivelat</li>
              <li>Kulutusluotot</li>
              <li>Osamaksut</li>
              <li>Pikavipit</li>
              <li>Muut korkeakorkoiset lainat</li>
            </ul>
            Erityisen kannattavaa on yhdistää korkokustannuksiltaan kalliita lainoja.
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="item-5" className="bg-white rounded-lg border border-gray-200">
          <AccordionTrigger className="px-4 py-3 text-left hover:no-underline w-full">
            Voinko hakea yhdistelylainaa yhdessä puolisoni kanssa?
          </AccordionTrigger>
          <AccordionContent className="px-4 pb-3 text-gray-600">
            Kyllä, yhdistelylainan voi hakea yhdessä puolison tai muun yhteishakijan kanssa. Yhteishakeminen usein 
            parantaa lainan saamisen mahdollisuuksia ja voi johtaa edullisempaan korkotasoon. Yhteishakijan kanssa 
            haettaessa molemmat hakijat ovat yhteisvastuussa lainan takaisinmaksusta.
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </motion.div>
  );
};
